export default __webpack_public_path__ + "static/media/ProductSans-Light.8eec7702.eot";